/* pkj-cvr-v21-proof.js - PEAK recent-orders toast (owner: pkj-cvr-v21).
   Real Shopify orders only. The feed is built on peak-server by /root/peak-social-proof/build_feed.py.
   This file never invents a name, a town, a model or a time.
   Below 900px (phones and small tablets, where the phone checkout bar can show): top of the screen,
   under the sticky header and any stuck sub-nav. pdpMobile 'off' = no toast on product pages below 900px.
   Desktop: bottom-left, lifted above any bottom-docked bar that it overlaps.
   Reading pages (cfg.gate === 'scroll', set by the snippet for articles, policies, Learn guides, financing,
   reviews, about and the founder letter): nothing shows until the visitor has scrolled past the first screen
   (scrollY > innerHeight * 0.9). After that the usual delay, gap, per-page and per-session counts apply.
   Config: #pkj-proof-config, written by snippets/pkj-cvr-v21-proof.liquid. */
(function () {
  'use strict';
  if (window.__pkjProof) return;
  window.__pkjProof = true;

  var root = document.getElementById('pkj-proof-root');
  var cfgEl = document.getElementById('pkj-proof-config');
  if (!root || !cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var PHONE_MAX = 767;     // same breakpoint as "Hide on mobile"
  var NARROW_MAX = 899;    // same breakpoint as the sticky checkout bar and the chapter nav
  var SESSION_CAP = 6;     // toasts per browser session, all pages together
  var POOL = 12;           // shuffle among the 12 freshest orders only
  var MAX_AGE_H = 720;     // feed lookback is 30 days
  var STALE_FEED_H = 48;   // feed not rebuilt for 48 h = paused or broken: show nothing
  var ALIA = '[id^="alia" i],[class^="alia" i],[class*=" alia" i],iframe[src*="alia" i],iframe[title*="alia" i]';
  var TOP = '#pk-sticky-header,#shopify-section-pkj-header,.pkj-pdp-chapters,.pkj-model-nav,.pkj-series-nav,.pkj-discovery-nav';
  var BOTTOM = '#pkj-cvr,#peak-action-footer,[data-pkj-sticky-checkout],.pkj-sticky-checkout,' +
    '.product-form__mobile-sticky-button.is-visible,#preview-bar-iframe,#PBarNextFrameWrapper,' + ALIA;

  var qs = new URLSearchParams(location.search);
  var flag = qs.get('pkj_proof');
  if (flag === '0') return;
  var force = flag === '1';
  var design = cfg.design === true;
  var loose = design || force;

  function ss(k, v) {
    try {
      if (arguments.length < 2) return sessionStorage.getItem(k);
      sessionStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function phone() { return window.innerWidth <= PHONE_MAX; }
  function narrow() { return window.innerWidth <= NARROW_MAX; }
  function count() { return Number(ss('pkj_proof_n')) || 0; }

  if (!loose) {
    if (navigator.webdriver) return;
    if (ss('pkj_proof_closed') === '1') return;
    if (count() >= SESSION_CAP) return;
    if (phone() && cfg.hideMobile) return;
    if (narrow() && cfg.isPdp && cfg.pdpMobile === 'off') return;
  }

  var here = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '';
  try { here = decodeURIComponent(here); } catch (e) {}
  var verb = String(cfg.verb || 'ordered').replace(/\s+(an?|the)\s*$/i, '').trim() || 'ordered';
  verb = verb.charAt(0).toUpperCase() + verb.slice(1);
  var seen = {};
  try { seen = JSON.parse(ss('pkj_proof_seen') || '{}') || {}; } catch (e) { seen = {}; }

  /* ---------- geometry ---------- */
  function all(sel) {
    try { return Array.prototype.slice.call(document.querySelectorAll(sel)); } catch (e) { return []; }
  }
  function shown(el) {
    if (el.checkVisibility) {
      if (!el.checkVisibility({ opacityProperty: true, visibilityProperty: true })) return false;
    } else {
      var s = getComputedStyle(el);
      if (s.display === 'none' || s.visibility === 'hidden' || Number(s.opacity) === 0) return false;
    }
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function coverage(el) {
    var r = el.getBoundingClientRect();
    var w = Math.max(0, Math.min(r.right, window.innerWidth) - Math.max(r.left, 0));
    var h = Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0));
    return (w * h) / (window.innerWidth * window.innerHeight);
  }
  // Something more important is open (menu, chat, call form, buy-box modal, Alia popup, typing): wait.
  function blocked() {
    if (document.hidden) return true;
    if (document.body.classList.contains('pkj-menu-open')) return true;
    if (document.querySelector('dialog[open],#peak-assist-panel[aria-hidden="false"],#peak-call-modal[aria-hidden="false"],.pk-mscrim.pk-open')) return true;
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
    return all('[aria-modal="true"],' + ALIA).some(function (el) {
      /* The theme's closed image lightbox (<product-modal aria-modal="true">) is fixed, full-screen and
         pointer-events:none on every PDP. It is not an open dialog, so it must not block the toast. */
      if (el.matches && el.matches('product-modal:not(.is-opened)')) return false;
      if (getComputedStyle(el).pointerEvents === 'none') return false;
      return shown(el) && coverage(el) > 0.12;
    });
  }
  // Phones: bottom edge of the sticky header, plus any sub-nav that is stuck right under it.
  function topOffset() {
    var y = 0;
    all(TOP).forEach(function (el) {
      if (!shown(el)) return;
      var r = el.getBoundingClientRect();
      if (r.bottom <= y) return;
      if (el.id === 'shopify-section-pkj-header') { y = r.bottom; return; }
      var p = getComputedStyle(el).position;
      if ((p === 'sticky' || p === 'fixed') && r.top <= y + 2) y = r.bottom;
    });
    return Math.max(0, Math.round(y));
  }
  // Desktop: clear any bottom-docked bar that overlaps our column (Assist pill sits right, so usually none).
  function bottomOffset(left, right) {
    var H = window.innerHeight, need = 24;
    all(BOTTOM).forEach(function (el) {
      if (!shown(el)) return;
      var r = el.getBoundingClientRect();
      if (r.top < H * 0.55 || r.top >= H || r.right <= left || r.left >= right) return;
      need = Math.max(need, Math.round(H - r.top) + 12);
    });
    return need;
  }

  /* ---------- toast ---------- */
  var toast = null, after = null, hideTimer = 0, watchTimer = 0, remaining = 0, startedAt = 0;
  var paused = false, stopped = false, frame = 0;

  function place() {
    if (!toast) return;
    if (narrow()) {
      var t = topOffset() + 8;
      toast.classList.add('pkj-proof--top');
      toast.style.bottom = 'auto';
      toast.style.top = t + 'px';
      toast.style.top = 'max(' + t + 'px, calc(env(safe-area-inset-top) + 8px))';
    } else {
      toast.classList.remove('pkj-proof--top');
      toast.style.top = 'auto';
      var r = toast.getBoundingClientRect();
      toast.style.bottom = bottomOffset(r.left, r.right) + 'px';
    }
  }
  function queuePlace() {
    if (frame) return;
    frame = requestAnimationFrame(function () { frame = 0; place(); });
  }
  window.addEventListener('scroll', queuePlace, { passive: true });
  window.addEventListener('resize', queuePlace);

  function node(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function agoText(h) {
    if (h < 1) return 'Within the last hour';
    if (h < 24) { var hh = Math.floor(h); return hh + (hh === 1 ? ' hour ago' : ' hours ago'); }
    var d = Math.floor(h / 24);
    return d + (d === 1 ? ' day ago' : ' days ago');
  }
  function build(it) {
    var linkable = !!it.handle && !here && !it.placeholder;
    var box = node('div', 'pkj-proof' + (linkable ? '' : ' pkj-proof--static') +
      (it.image ? '' : ' pkj-proof--noimg') + (narrow() ? ' pkj-proof--top' : ''));
    var link = node(linkable ? 'a' : 'div', 'pkj-proof__link');
    if (linkable) {
      link.href = '/products/' + encodeURIComponent(it.handle);
      link.addEventListener('click', function () {
        try { if (window.PK && PK.track) PK.track('pk_proof_click', { pk_handle: it.handle, model: it.model }); } catch (e) {}
      });
    }
    var media = node('span', 'pkj-proof__img');
    media.setAttribute('aria-hidden', 'true');
    if (it.image) {
      var img = node('img');
      img.alt = '';
      img.width = 72;
      img.height = 72;
      img.decoding = 'async';
      img.addEventListener('error', function () { box.classList.add('pkj-proof--noimg'); });
      img.src = it.image;
      media.appendChild(img);
    }
    var body = node('span', 'pkj-proof__body');
    if (it.placeholder) {
      body.appendChild(node('span', 'pkj-proof__who', 'Recent orders'));
      body.appendChild(node('span', 'pkj-proof__what', 'Real orders from the feed show here.'));
    } else {
      body.appendChild(node('span', 'pkj-proof__who', it.who));
      var what = node('span', 'pkj-proof__what', verb + ' the ');
      what.appendChild(node('b', null, it.model));
      body.appendChild(what);
      var meta = node('span', 'pkj-proof__meta');
      var dot = node('span', 'pkj-proof__dot');
      dot.setAttribute('aria-hidden', 'true');
      meta.appendChild(dot);
      meta.appendChild(document.createTextNode(agoText(it.age) + (cfg.meta ? ' · ' + cfg.meta : '')));
      body.appendChild(meta);
    }
    link.appendChild(media);
    link.appendChild(body);
    var x = node('button', 'pkj-proof__x', '×');
    x.type = 'button';
    x.setAttribute('aria-label', 'Dismiss recent orders');
    x.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); stop(true); });
    box.appendChild(link);
    box.appendChild(x);
    box.addEventListener('mouseenter', pause);
    box.addEventListener('mouseleave', resume);
    box.addEventListener('focusin', pause);
    box.addEventListener('focusout', resume);
    return box;
  }

  function arm() {
    clearTimeout(hideTimer);
    startedAt = Date.now();
    hideTimer = setTimeout(function () { hide(after); }, remaining);
  }
  function pause() {
    if (!toast || paused || design) return;
    paused = true;
    clearTimeout(hideTimer);
    remaining = Math.max(1500, remaining - (Date.now() - startedAt));
  }
  function resume() {
    if (!toast || !paused) return;
    paused = false;
    arm();
  }
  function hide(cb) {
    clearTimeout(hideTimer);
    clearInterval(watchTimer);
    paused = false;
    var n = toast;
    toast = null;
    if (!n) return;
    n.classList.remove('is-on');
    setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 300);
    if (typeof cb === 'function') cb();
  }
  function stop(byUser) {
    stopped = true;
    if (byUser) ss('pkj_proof_closed', '1');
    hide();
  }
  function show(it, done, tries) {
    if (stopped) return;
    tries = tries || 0;
    if (!design && blocked()) {
      if (tries < 15) setTimeout(function () { show(it, done, tries + 1); }, 4000);
      else done();
      return;
    }
    after = done;
    toast = build(it);
    root.appendChild(toast);
    if (!design) { try { if (window.PK && PK.track) PK.track('pk_proof_view', { pk_handle: it.handle || '', model: it.model }); } catch (e) {} }
    place();
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (toast) toast.classList.add('is-on'); }); });
    if (it.key) { seen[it.key] = 1; ss('pkj_proof_seen', JSON.stringify(seen)); }
    if (!loose) ss('pkj_proof_n', String(count() + 1));
    if (design) return; // theme editor: keep the card on screen
    remaining = cfg.stay || 7000;
    arm();
    watchTimer = setInterval(function () { if (toast && blocked()) hide(after); }, 800);
  }

  /* ---------- feed ---------- */
  var NAME = /^[A-Za-zÀ-ɏ][A-Za-zÀ-ɏ'. -]{0,23}$/;
  var PLACE = /^[A-Za-zÀ-ɏ][A-Za-zÀ-ɏ'. -]{0,39}$/;
  var JUNK = /^(test|testing|n\/?a|none|null|undefined|customer|guest|mr|mrs|ms|dr)\.?$/i;
  function clean(raw, drift) {
    if (!raw || typeof raw !== 'object') return null;
    var model = String(raw.model || '').trim();
    if (!/^[A-Za-z][A-Za-z0-9'. -]{0,29}$/.test(model)) return null;
    var h = Number(raw.ago_h);
    if (!isFinite(h) || h < 0) return null;
    var age = h + drift;
    if (age > MAX_AGE_H) return null;
    var name = String(raw.name || '').trim();
    if (!NAME.test(name) || JUNK.test(name)) name = 'Someone';
    var city = String(raw.city || '').trim();
    if (!PLACE.test(city)) city = '';
    var state = String(raw.state || '').trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(state)) state = '';
    var where = city && state ? city + ', ' + state : (city || state);
    var who = name === 'Someone' ? (where ? 'Someone in ' + where : 'A PEAK customer') : name + (where ? ' in ' + where : '');
    var handle = String(raw.handle || '');
    if (!/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle)) handle = '';
    var image = String((cfg.images || {})[handle] || '');
    if (image.indexOf('//') === 0) image = 'https:' + image;
    if (!/^https:\/\/cdn\.shopify\.com\//.test(image) && image.indexOf(location.origin + '/cdn/shop/') !== 0) image = '';
    return { who: who, model: model, handle: handle, image: image, age: age, key: [name, city, state, model, handle].join('|') };
  }
  function pick(items, generated) {
    var drift = 0;
    var g = Date.parse(generated || '');
    if (isFinite(g)) {
      drift = Math.max(0, (Date.now() - g) / 3600000);
      if (drift > STALE_FEED_H) return [];
    }
    var list = (Array.isArray(items) ? items : []).map(function (it) { return clean(it, drift); }).filter(Boolean);
    list.sort(function (a, b) { return a.age - b.age; });
    var unseen = list.filter(function (x) { return !seen[x.key]; });
    if (unseen.length) list = unseen;
    var pool = list.slice(0, POOL);
    for (var i = pool.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = pool[i]; pool[i] = pool[j]; pool[j] = t;
    }
    if (here) {
      var mine = list.filter(function (x) { return x.handle === here; })[0];
      if (mine) { pool = pool.filter(function (x) { return x !== mine; }); pool.unshift(mine); }
    }
    return pool;
  }
  function run(pool) {
    if (design) { show(pool[0] || { placeholder: true }, function () {}); return; }
    if (!pool.length) return;
    var max = Math.min(Math.max(1, cfg.max || 3), phone() ? 2 : 6, pool.length);
    var i = 0;
    function next() {
      if (stopped || i >= max) return;
      if (!loose && count() >= SESSION_CAP) return;
      show(pool[i++], function () { setTimeout(next, cfg.gap || 25000); });
    }
    function go() { setTimeout(next, cfg.initial || 6000); }
    // Reading pages: hold everything until the visitor has scrolled past the first screen, then run as usual.
    if (cfg.gate === 'scroll' && !pastFold()) {
      var onScroll = function () {
        if (!pastFold()) return;
        window.removeEventListener('scroll', onScroll);
        go();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      return;
    }
    go();
  }
  function pastFold() {
    var y = window.scrollY != null ? window.scrollY : (window.pageYOffset || 0);
    return y > window.innerHeight * 0.9;
  }
  function load() {
    var c = null;
    try { c = JSON.parse(ss('pkj_proof_feed') || 'null'); } catch (e) { c = null; }
    if (c && Date.now() - c.t < 300000 && Array.isArray(c.d)) { run(pick(c.d, c.g)); return; }
    if (!window.fetch) return;
    fetch(cfg.feed, { mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var items = d && Array.isArray(d.items) ? d.items : [];
        ss('pkj_proof_feed', JSON.stringify({ t: Date.now(), g: d && d.generated, d: items }));
        run(pick(items, d && d.generated));
      })
      .catch(function () { if (design) run([]); });
  }
  function start() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 3000 });
    else setTimeout(load, 1500);
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
